// Cosmetic only, for the currency <select>; unrecognized codes fall back to the ISO code.
export const CURRENCY_SYMBOLS = {
  USD: "$",
  EUR: "€",
  GBP: "£",
  INR: "₹",
  AUD: "A$",
  CAD: "C$",
  AED: "د.إ",
  SGD: "S$",
  JPY: "¥",
  SAR: "﷼",
  CNY: "¥",
};